export default __webpack_public_path__ + "non_motorized_shade_icon.png";